import axios from "axios";
import router from "@/services/router";

const API_URL = process.env.NODE_ENV === 'development' ? '/' : 'https://vk.timekraken.ru/';

export default {
    state: {
        menu: [],
        profile: [],
    },

    mutations: {
        setProfile(state, profile) {
            state.profile = profile;
            localStorage.setItem("profile", JSON.stringify(profile));
        },
        setMenu(state, menu) {
            state.menu = menu;
            localStorage.setItem("menu", JSON.stringify(menu));
        },
    },

    actions: {
        login(ctx, data) {
            console.log("Login");
            let formData = new FormData();
            formData.append("username", data.username);
            formData.append("password", data.password);
            axios.post(API_URL + "site/login", formData).then((res) => {
                console.log(res.data);
                console.log(res.data.menu);
                console.log(res.data.menu[0].url);
                if (res.data.alert) ctx.commit("setAlert", res.data.alert);
                if (res.data && res.data.token) {
                    localStorage.setItem("AUTH", res.data.token);
                    ctx.commit("setProfile", res.data.me);
                    ctx.commit("setMenu", res.data.menu);
                    router.push(res.data.menu[0].url);
                    // ctx.dispatch("setActiveMemu", "/projects");
                }
            });
        },

        registration(ctx, data) {
            let formData = new FormData();
            formData.append("username", data.username);
            formData.append("email", data.email);
            formData.append("password", data.password);
            axios.post(API_URL + "site/registration", formData).then((res) => {
                if (res.data.alert) ctx.commit("setAlert", res.data.alert);
                if (res.data && res.data.token) {
                    localStorage.setItem("AUTH", res.data.token);
                    ctx.commit("setProfile", res.data.me);
                    ctx.commit("setMenu", res.data.menu);
                    router.push("/projects");
                    ctx.dispatch("setActiveMemu", "/projects");
                }
            });
        },

        logout(ctx) {
            localStorage.removeItem("AUTH");
            localStorage.removeItem("profile");
            ctx.commit("setProfile", null);
            ctx.commit("setMenu", null);
            router.push({ name: "Login" });
        },

        getProfile(ctx) {
            if (ctx.state.profile.id && ctx.state.menu) {
                return;
            }

            let profile = localStorage.getItem("profile");
            if (profile && profile != "undefined") {
                ctx.commit("setProfile", JSON.parse(profile));
            }

            let menu = localStorage.getItem("menu");
            if (menu) {
                ctx.commit("setMenu", JSON.parse(menu));
            }

            if (!ctx.state.profile?.id || !ctx.state.menu) {
                router.push("/login");
            }
        },

        // getProfile(ctx) {
        //     if (ctx.state.profile.id && ctx.state.menu) {
        //         return;
        //     }

        //     let profile = localStorage.getItem("profile");
        //     if (profile && profile != "undefined") {
        //         ctx.commit("setProfile", JSON.parse(profile));
        //     }

        //     API.GET("user/menu").then((res) => {
        //         console.log(res.data);
        //         ctx.commit("setMenu", res.data.menu);
        //     });

        //     if (!ctx.state.profile?.id) {
        //         router.push("/login");
        //     }

        //     // let menu = localStorage.getItem("menu");
        //     // if (menu) {
        //     //     ctx.commit("setMenu", JSON.parse(menu));
        //     // }
        // },
    },

    getters: {
        menu(state) {
            return state.menu;
        },
        profile(state) {
            return state.profile;
        },
    },
};
